import { Injectable } from '@angular/core';
import { JwtResponse } from '../models/jwt-response.model';

const USER_SESSION_KEY = 'UserSession';

@Injectable({ providedIn: 'root' })
export class TokenStorageService {

  signOut(): void {
    window.sessionStorage.clear();
  }

  saveUserSession(session: JwtResponse): void {
    window.sessionStorage.removeItem(USER_SESSION_KEY);
    window.sessionStorage.setItem(USER_SESSION_KEY, JSON.stringify(session));
  }

  getUserSession(): JwtResponse | null {
    const raw = sessionStorage.getItem(USER_SESSION_KEY);
    return raw ? (JSON.parse(raw) as JwtResponse) : null;
  }

  getToken(): string | null {
    return this.getUserSession()?.token ?? null;
  }

  getAuthorities(): string[] {
    const raw = this.getUserSession()?.authorities as unknown;
    if (!raw || !Array.isArray(raw)) return [];
    return raw.map((a: unknown) =>
      typeof a === 'string' ? a : (a as { authority: string })?.authority ?? ''
    );
  }

  getUserId(): number | null {
    return this.getUserSession()?.userId ?? null;
  }

  getFullName(): string {
    const session = this.getUserSession();
    if (!session) return '';
    return `${session.firstName} ${session.lastName}`.trim();
  }
}
